module.exports = __webpack_public_path__ + "static/media/PROD_ASS2.c0ba6323.png";